module.exports = __webpack_public_path__ + "static/media/circleLocation.9e3620ae.svg";